<template>
  <div class="edit-div ivu-input fn-left" :class="{'split': isSplit}"
       v-html="innerText"
       :placeholder="placeholder"
       :contenteditable="canEdit"
       @keydown="handleKeyPress"
       @focus="onFocus"
       @paste="handlePaste"
       @blur="onBlur"
       @click="saveSelection"
       @mouseup="saveSelection"
       @keyup="saveSelection"
       @input="changeText">

  </div>
</template>
<script>
import { saveSelection, restoreSelection} from '@/common/utils/Caret';
function escapeAttrs(str) {
  return str.replace(/<\s*br\s[^>]*\/?>/, '<br/>').replace(/<\s*div\s[^>]*>/g, '<div>').replace(/<\s*a\s([^>]*)>/g, (whole, attrs) => {
    const attrRegex = /\S+\s*=\s*["']?(?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.["']?/mg
    const outAttr = []
    let matches = attrs.match(attrRegex)
    matches = matches || []
    matches.forEach((k) => {
      const idx = k.indexOf('=')
      if(idx !== -1) {
        const name = k.substring(0, idx) || ''
        const value = k.substring(idx + 1) || ''
        if(name === 'href' || name.startsWith('data-miniprogram-')) {
          outAttr.push(`${name.trim()}=${value.trim()}`)
        }
      }
    })
    const validAttrs = outAttr.join(' ')
    return `<a ${validAttrs}>`
  })
}

let currRange = null

function htmlDecode(input, enableLink){
  const e = document.createElement('textarea');
  e.innerHTML = input;
  // handle case of empty input
  const decoded = e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
  let regex
  if(enableLink) {
    regex = /<\/?(?!a)(?!drip\-prop)(?!br)(?!div)(\w*)\b[^>]*>/g
  } else {
    regex = /<\/?(?!drip\-prop)(?!br)(?!div)(\w*)\b[^>]*>/g
  }
  const r = decoded.replace(regex, '')
  return escapeAttrs(r)
}
export default{
  props: {
    value: {
      type: String,
      default: '',
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    isSplit: {
      type: Boolean,
      default: false,
    },
    enableLink: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      innerText: null,
      isLocked: false,
    };
  },
  watch: {
    'value'(nv) {
      if(this.$el.innerHTML !== nv) {
        this.innerText = this.value;
        this.$nextTick(() => {
          this.saveSelection()
        })
      }
    },
  },
  methods: {
    saveSelection() {
      currRange = saveSelection(this.$el)
    },
    restoreSelection() {
      restoreSelection(this.$el, currRange)
    },
    handlePaste() {
      this.$nextTick(() => {
        this.changeText()
      })
    },
    changeText() {
      const decoded = htmlDecode(this.$el.innerHTML, this.enableLink)
      this.$emit('input', decoded);
      this.saveSelection()
    },
    onFocus() {
      this.isLocked = true;
    },
    onBlur() {
      this.isLocked = false;

    },
    handleKeyPress(e) {
      if (e.keyCode === 13 && !this.isSplit) {
        e.preventDefault();
      }
    },
  },
  mounted() {
    this.innerText = this.value;
    if(this.value) {
      this.saveSelection()
    }
  },
};
</script>
<style scoped>
[placeholder]:empty::before {
    content: attr(placeholder);
    color: #999;
}

[placeholder]:empty:focus::before {
  content: "";
}
</style>
<style>
.edit-div a[data-miniprogram-appid]:before {
  content: '';
  display: inline-block;
  line-height: 1;
  background-size: 12px 12px;
  background-repeat: no-repeat;
  background-image: url(https://qiniu.drip.im/news-thumb/5c1b187e4576d.png);
  vertical-align: middle;
  font-size: 11px;
  color: #888;
  border-radius: 10px;
  background-color: #f4f4f4;
  margin-right: 6px;
  margin-top: -4px;
  background-position: center;
  height: 20px;
  width: 20px;
}
.edit-div a {
  color: #607fa6;
}
.edit-div {
  width: 85%;
  margin-right: 15px;
  overflow: auto;
  word-break: break-all;
  outline: none;
  user-select: text;
  white-space: pre-wrap;
  text-align: left;
}
.split {
  min-height: 50px;
  height: auto;
}
.edit-div drip-prop {
  background: #C4DDFA;
  border: 1px solid #93C4E2;
  border-radius: 10px;
  padding: 0px 3px;
  color: #000;
  margin: 0 2px;
}
.edit-div.ivu-input {
  padding: 6px 7px;
}
</style>
